import { useState, useEffect } from 'react';

// Cortes únicos del rediseño mobile: mobile <760px, tablet 760-1179px, desktop >=1180px.
// Deben coincidir con el @media (max-width: 759.98px) de frontend/src/style/mobile.css —
// si se cambia un valor acá, hay que cambiarlo también ahí.
export const MOBILE_MAX = 759.98;
export const TABLET_MAX = 1179.98;

const calcularBreakpoint = () => {
    const ancho = window.innerWidth;
    if (ancho <= MOBILE_MAX) return 'mobile';
    if (ancho <= TABLET_MAX) return 'tablet';
    return 'desktop';
};

export default function useBreakpoint() {
    const [breakpoint, setBreakpoint] = useState(calcularBreakpoint);

    useEffect(() => {
        const mqMobile = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`);
        const mqTablet = window.matchMedia(`(max-width: ${TABLET_MAX}px)`);
        const actualizar = () => setBreakpoint(calcularBreakpoint());

        // 'change' (no 'resize' crudo): solo re-renderiza al cruzar un corte, no en cada pixel.
        mqMobile.addEventListener('change', actualizar);
        mqTablet.addEventListener('change', actualizar);
        actualizar();

        return () => {
            mqMobile.removeEventListener('change', actualizar);
            mqTablet.removeEventListener('change', actualizar);
        };
    }, []);

    return {
        breakpoint,
        esMobile: breakpoint === 'mobile',
        esTablet: breakpoint === 'tablet',
        esDesktop: breakpoint === 'desktop',
    };
}
